/* Copyright (c) 2020-present CloudIO Inc */

import { infoBoxShowOn } from 'componentregistry/registry/constants';
import {
  CommonProps,
  defaultCommonProps,
} from '../../layout/Sidebar/panels/PropertiesView/CommonProperties';
import { BaseComponentItem } from '../../registry/Component.type';

export interface InfoBoxItem extends BaseComponentItem {
  props: InfoBox;
  type: 'InfoBox';
}

export interface InfoBox extends CommonProps {
  borderRadius?: number;
  showOn: keyof typeof infoBoxShowOn;
  infoBoxHeight: number;
  infoBoxWidth: number;
}

export const defaultValue: Required<InfoBox> = {
  ...defaultCommonProps,
  borderRadius: 0,
  showOn: 'hover',
  infoBoxHeight: 300,
  infoBoxWidth: 400,
};
